// extracted by mini-css-extract-plugin
module.exports = {"Morphology":"Morphology_Morphology__2aP7Q","Instructions":"Morphology_Instructions__1D-QI","LanguageCard":"Morphology_LanguageCard__3TZKH"};